import React, { FC } from 'react';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { connect } from 'react-redux';
import { productionBatchStatistics } from '@reducers/statistics';
import { getNCFileById } from '@reducers/manufacture';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useBatchDetails } from '@v2/pages/common/hooks/useBatchDetails';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { updateHeaderConfig } from '@reducers/details';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';

interface BatchDetailsNCFileTimelineProps {}

const BatchDetailsNCFileTimelineComponent: FC<BatchDetailsNCFileTimelineProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
}) => {
  const title = useTitle();

  useBatchDetails({
    clearTools,
    getNCFileById,
    getTools,
    productionBatchStatistics,
    updateHeaderConfig,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <MultiMachineTimeline />
    </DetailsPageWrapper>
  );
};

const BatchDetailsNCFileTimeline = connect(null, {
  getNCFileById,
  clearTools,
  getTools,
  productionBatchStatistics,
  updateHeaderConfig,
})(BatchDetailsNCFileTimelineComponent);

export { BatchDetailsNCFileTimeline };
